import React, { useState } from 'react';
import classnames from 'classnames';
import { useMediaQuery } from 'react-responsive'
import Icon from 'components/Icon/Icon';
import { SvgIcons } from 'common/consts/svgIcons';
import styles from './PlanDetails.module.scss';

interface Props {
  heading?: string;
  children: React.ReactNode | React.ReactNode[];
  numberOfColumns?: number;
  headingOnTheLeft?: boolean;
  showPlanDetailsLabel?: string;
  hidePlanDetailsLabel?:string;
}

const PlanDetails = ({
  heading,
  children,
  numberOfColumns,
  headingOnTheLeft,
  showPlanDetailsLabel,
  hidePlanDetailsLabel
}: Props) => {
  const [showDetails, setShowDetails] = useState(false);
  const isMobileSize = useMediaQuery({ maxWidth: 767 });

  return (
    <div
      className={classnames(
        styles.PlanDetails,
        headingOnTheLeft && styles.inRow,
      )}
    >
      <h2 className={styles.heading}>{heading}</h2>
      <div
        className={classnames(
          styles.content,
          isMobileSize && !showDetails ? ' plandetail_active' : '',
        )}
        style={{ gridTemplateColumns: `repeat(${numberOfColumns || 4}, 1fr)` }}
      >
        {children}
      </div>
      <div className={styles.mobilebutton}>
        <button
          className={classnames(
            styles.toggleBtn,
            showDetails && styles.expanded,
          )}
          onClick={() => setShowDetails(!showDetails)}
        >
          {showDetails ? hidePlanDetailsLabel : showPlanDetailsLabel}
          <Icon type={SvgIcons.CHEVRON_ICON} width={14} height={14} className={classnames(styles.expandIcon, showDetails && styles.expanded)} />
        </button>
      </div>
    </div>
  );
};

export default PlanDetails;